"use client";

import { Button } from "@/ds/components/Button";
import { Globe } from "@/ui/components/NotFound/Globe";
import { Globe as GlobeIcon, Home } from "lucide-react";
import Link from "next/link";
import { useLayoutEffect, useState } from "react";

const FACTS = [
  "There are more than 195 countries to explore — this page just isn't one of them.",
  "The word 'nomu' (飲む) means 'to drink' in Japanese. Cheers to new adventures.",
  "You're only 1 click away from your next trip.",
  "Even Magellan took a wrong turn. Several, actually.",
  "The longest place name in the world has 85 characters. This URL has… fewer.",
  "70% of the Earth is water. The other 30% is waiting for your pins.",
];

export function NotFound() {
  const [globeSize, setGlobeSize] = useState(280);
  const [fact, setFact] = useState(FACTS[0]);

  useLayoutEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)");
    const apply = () => setGlobeSize(mq.matches ? 200 : 280);
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, []);

  useLayoutEffect(() => {
    setFact(FACTS[Math.floor(Math.random() * FACTS.length)]);
  }, []);

  return (
    <main
      id="main-content"
      className="flex min-h-screen flex-col items-center justify-center bg-bg px-4 py-12 text-center"
    >
      <div className="flex w-full max-w-md flex-col items-center sm:max-w-lg">
        <Globe size={globeSize} className="mb-8 shrink-0" />

        <h1 className="font-medium tracking-[-3px] text-fg text-[56px] leading-none sm:text-[72px]">
          404
        </h1>

        <h2 className="mt-4 text-xl font-medium text-fg">You&apos;ve wandered off the map</h2>

        <p className="mt-3 max-w-[320px] text-sm leading-relaxed text-muted-fg">
          This page doesn&apos;t exist — but that&apos;s the beauty of exploring. Let&apos;s get you back on
          track.
        </p>

        <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-center">
          <Button
            asChild
            variant="solid"
            tone="secondary"
            className="h-auto w-full gap-1.5 rounded-lg px-5 py-2.5 text-sm font-medium sm:w-auto"
            leftIcon={<Home className="size-4 shrink-0" aria-hidden />}
          >
            <Link href="/">Go home</Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="h-auto w-full gap-1.5 rounded-lg border-brand-secondary bg-transparent px-5 py-2.5 text-sm font-medium text-brand-secondary hover:bg-brand-secondary/10 sm:w-auto"
            leftIcon={<GlobeIcon className="size-4 shrink-0" aria-hidden />}
          >
            <Link href="/explore">Explore the map</Link>
          </Button>
        </div>

        <p className="mt-10 w-full max-w-[380px] rounded-xl border border-border bg-muted px-4 py-3 text-left text-[13px] leading-relaxed text-muted-fg sm:mx-0">
          {fact}
        </p>
      </div>
    </main>
  );
}
